(function(){
'use strict';

/**
 * @name htmlToPlaintext
 * @kind filter
 */

function htmlToPlaintext() {
  return function (text) {
    // Decode the text before sanitizing
    var decoded = typeof text === 'string' ? window.he.decode(text) : '';

    // Sanitize the decoded text
    var clean = window.DOMPurify.sanitize(decoded);

    // Return it as sanitized html
    return clean;
  };
}

angular.module('classy').filter('htmlToPlaintext', htmlToPlaintext);
})();